import { Component, OnInit } from '@angular/core';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';

@Component({
  selector: 'app-xml2json',
  templateUrl: './xml2json.component.html',
  styleUrls: ['./xml2json.component.scss']
})
export class Xml2jsonComponent implements OnInit {
  jsonObject: any;
  xmlObject: any;

  constructor(private localAssetReaderService: LocalAssetReaderService, private xmlToJsonParserService: XmlToJsonParserService) {}

  async ngOnInit() {
    const xmlData = await this.localAssetReaderService.getContent('./assets/json/search-flights/request/search-flights-request1.xml');

    this.jsonObject = this.xmlToJsonParserService.parseXMLToJSON(xmlData as any);

    // console.log('json object: ', JSON.stringify(this.jsonObject));

    this.xmlObject = this.xmlToJsonParserService.buildXMLFromJSON(this.jsonObject);

    // console.log('xml object: ', this.xmlObject);
  }
}
